<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
         

          <el-col :span="24">
            <el-form-item label="卡号" prop="cardNo">
              <el-input
                clearable
                disabled
                v-model="form.cardNo"
                placeholder="请输入卡号"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" >
            <el-form-item label="老人姓名" prop="name" >
             
              <el-input
                clearable
             disabled
                v-model="form.name"
                placeholder="请输入老人姓名"
                maxlength="50"
              >
              
             
            </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="身份证号" prop="idNumber">
              <el-input
                clearable
                disabled
                v-model="form.idNumber"
                placeholder="请输入身份证号"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="性别" prop="sex">
              <el-select disabled v-model="form.sex" style="width: 100%" placeholder="性别">
              <el-option
                v-for="(item, index) in sexList"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="余额" prop="sex">
              <money-input
                 v-model="form.balance"
                templateName="元"
                disabled
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="充值金额" prop="amount">
              <money-input
                 v-model="form.amount"
                templateName="元"
                
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model === 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
    <hr-dialog
      title=""
      :allowFull="false"
      width="60%"
      @close="closeAddOldManDialog"
      :visible.sync="choiceUserVisible"
    >
      <template slot="body">
        <chocieOldPeopleVue
          v-if="choiceUserVisible"
          :nursinghomeId="form.nursinghomeId"
          @getData="getData"
        ></chocieOldPeopleVue>
      </template>
    </hr-dialog>
  </div>
</template>
<script>
import { getDictionary } from '@/api/common.js';
import { getNursinghome } from '../api/serveItemManage';
import {smartcardrecharge } from '@/api/nursingHome/nursingCard';
import chocieOldPeopleVue from './chocieOldPeople.vue';
export default {
  components: { chocieOldPeopleVue },
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      sexList: [],
      projectList: [],
      choiceUserVisible: false,
      form: {
        nursinghomeId: '',
        name: '',
        idNumber: '',
        sex: '',
        amount:"",
        balance:""
      },
      formRules: {
       
        amount: [{ required: true, message: '充值金额不能为空', trigger: 'blur' }],
      },
      selfCareConditionList: [],
      relationshipList: [],
      consultWayTypeList: [],
      mediaChannelTypeList: [],
      consultTypeList: [],
      nursinghomeIdList: [],
    };
  },
  created() {
    console.log(this.model);
    console.log(this.row);
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    
   
     initData() {
      getDictionary("sex").then(res=>{
        this.sexList = res.data
      })
      console.log("**************",this.row)
     this.form.id = this.row.id
    
     this.form.idNumber = this.row.idNumber
     this.form.cardNo = this.row.cardNo
     this.form.balance = this.row.balance
     this.form.name = this.row.name
     this.form.sex = this.row.sex
    
    

     
    },
    saveRecord() {

      this.$refs['formRef'].validate((valid) => {
          if (valid) {
            smartcardrecharge(this.form).then((res) => {
              this.$message.success('充值成功');
              this.$emit('success');
            });
          }
        });
      
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
